<template>
    <div v-if="this.$store.state.settings.basket.basket.length > 0" class="container">
        <h1 class="sec-title">{{ trans('Basket') }}</h1>
        <cardHorizontal v-if="basketState != 3" :type="1" :cards="basket.products_for_purchase" />
        <cardHorizontal v-if="basketState != 1" :type="2" :cards="basket.products_unavailable_for_purchase" />
        <div class="cart-sec__element_wrapper" v-if="!basket.products_for_purchase && !basket.products_unavailable_for_purchase">
            <h3 class="welcome-sec__advantages-title">
                {{ this.trans('There is nothing in the basket') }}
            </h3>
            <br><br>
        </div>
        <div class="cart-sec__down-row">
            <div class="basket-blackfriday-banner-mob">
            </div>
            <div class="basket-promo-wrap">
                <div v-if="isVip" class="cart-sec__vip-block">
                    <div class="cart-sec__vip-row">
                        <span class="cart-sec__vip-label">{{ vipDiscountLabel }}</span>
                        <label class="cart-sec__vip-toggle">
                            <input
                                type="checkbox"
                                class="cart-sec__vip-toggle-input"
                                v-model="vipDiscountEnabled"
                                @change="onVipToggleChange"
                            >
                            <span class="cart-sec__vip-toggle-slider" aria-hidden="true"></span>
                        </label>
                    </div>
                    <Promo :show="!isSecretCardExists" />
                </div>
                <Promo v-else :show="!isSecretCardExists" />
            </div>
            <div class="basket-blackfriday-banner">
            </div>
            <div v-if="basketState != 3" class="cart-sec__all-price">
                <ul class="list cart-sec__list">
                    <li class="list__element cart-sec__list-element">
                        <p class="cart-sec__text">{{ trans('Total Purchase Amount') }}:</p>
                        <span>{{ basket.amount_without_discount }} {{ basket.currency_sign }}</span>
                    </li>
                    <li class="list__element cart-sec__list-element" v-if="basket.amount_of_discount">
                        <p class="cart-sec__text">{{trans('Discount')}}:</p>
                        <span>{{ basket.amount_of_discount }} {{ basket.currency_sign }}</span>
                    </li>
                </ul>
                <div class="cart-sec__end-price-row end-price-row">
                    <p class="end-price-row__text">{{trans('Total')}}:</p>
                    <span class="end-price-row__value">{{ basket.amount_to_be_paid }} {{ basket.currency_sign }}</span>
                </div>
                <a :href="'/personal/basket/make'" @click.prevent="basketValBeforOrdering('/personal/basket/make')">
                    <button class="btn btnV2 basket-success" id="basket-success">{{ trans('place an order') }}</button>
                </a>
            </div>
        </div>
    </div>
    <div v-else class="container">
        <h2>{{trans("There is nothing in the basket")}} </h2>
    </div>
    <Viewed></Viewed>
</template>

<script>
import cardHorizontal from '../../components/card-horizontal.vue'
import Promo from '../../components/promo.vue'
import Viewed from '../../components/viewed.vue'
import { viewCart } from '../../services/ga4Ecommerce.js'

export default {
    name: "basket",
    components: {
        cardHorizontal, Promo ,Viewed
    },
    data() {
        return {
            basket: {},
            isSecretCardExists: false,
            isVip: Boolean(this.$store.state.settings.user?.is_vip),
            vipDiscountEnabled: this.getVipDiscountEnabled(),
            vipDiscountPercent: 30,
            /**
             * 1 - содержит только доступные товарные предложения,
             * 2 - содержит доступные и недоступыне товарные предложения,
             * 3 - нет ни одного товарного предложения доступного для оформления
             */
            basketState: 1,
        }
    },
    computed: {
        vipDiscountLabel() {
            const percent = Math.round(this.vipDiscountPercent)
            return this.trans('VIP discount', percent)
        },
    },
    mounted() {
        if (this.$store.state.settings.basket.basket.length > 0){
            this.getBasket(true)
        }
        if (this.$store.state.settings.site_id === 1 && import.meta.env.MODE === 'production') {
            _tmr.push({ type: 'reachGoal', id: 3290316, value: 5, goal: 'view_cart'});
        }
    },
    methods: {
        async getBasket(trackView = false) {
            let params = {};
            params.guest_id = this.$store.state.settings.guest.id;
            const promo = this.getStoredPromo()
            const payload = {
                ...this.setParam(params),
            }
            if (promo?.code && promo?.promo_token) {
                payload.promo = promo.code
                payload.token = promo.promo_token
            }
            this.appendVipDiscountParam(payload)
            await axios.post('/api/v1/get-basket', payload)
                .then(data => {
                    const d = data.data
                    if (d.promo_clear) {
                        localStorage.removeItem('promo')
                        localStorage.removeItem('promo_token')
                        this.$store.state.settings.promo = null
                    }
                    if (typeof d.is_vip === 'boolean') {
                        this.isVip = d.is_vip
                    }
                    if (d.vip_discount_percent) {
                        this.vipDiscountPercent = d.vip_discount_percent
                    }
                    this.basket = d.basket
                    if (trackView) {
                        viewCart(
                            d.basket?.products_for_purchase,
                            d.basket?.amount_to_be_paid_num,
                            d.basket?.currency_code
                        )
                    }
                })

        },
        onVipToggleChange() {
            this.setVipDiscountEnabled(this.vipDiscountEnabled)
            this.getBasket()
        },
        basketValBeforOrdering(url) {
            window.location.replace(url)
        },
    },
    watch: {
        '$store.state.settings.basket': {
            handler(newBasket, oldBasket) {
                if (JSON.stringify(newBasket) !== JSON.stringify(oldBasket)) {
                    this.getBasket()
                }
            },
            deep: true,
        }
    },
}
</script>
